const hasDefaultAttribute = (element: HTMLElement, attribute: string) =>
  element.getAttribute(`data-setted-${attribute}`) !== 'true';

/**
 * Este método tem a função de colocar um atributo em um elemento HTML e além
 * disso já deixar marcado com `[data-setted-{ATRIBUTO}]` para quando for preciso
 * remover.
 *
 * @param element elemento HTML para adicionar o atributo
 * @param attribute nome do atributo a ser adicionado
 * @param value valor do atributo a ser adicionado, padrão "true"
 *
 * @category DOM
 */
export const setAttribute = (element: HTMLElement, attribute: string, value = 'true') => {
  if (element.hasAttribute(attribute)) {
    return;
  }

  element.setAttribute(attribute, value);
  element.setAttribute(`data-setted-${attribute}`, 'true');
};

/**
 * Este método tem a função de remover os atributos HTML que foram adicionados
 * pelo "setAttribute".
 *
 * @param element elemento para remover o atributo anteriormente adicionado
 * @param attribute nome do atributo a ser removido do elemento
 *
 * @category DOM
 */
export const removeSettedAttribute = (element: HTMLElement, attribute: string) => {
  if (!hasDefaultAttribute(element, attribute)) {
    element.removeAttribute(`data-setted-${attribute}`);
    element.removeAttribute(attribute);
  }
};
